// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_pagination-container__Helby {
  display: flex;
  list-style-type: none;
  justify-content: center;
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7 {
  padding: 0 12px;
  height: 32px;
  text-align: center;
  margin: auto 4px;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  box-sizing: border-box;
  align-items: center;
  letter-spacing: 0.01071em;
  border-radius: 16px;
  line-height: 1.43;
  font-size: 13px;
  min-width: 32px;
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7.Pagination_dots__Zgesj:hover {
  background-color: transparent;
  cursor: default;
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7:hover {
  background-color: rgba(0, 0, 0, 0.04);
  cursor: pointer;
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7.Pagination_selected__0m73l {
  background-color: rgba(0, 0, 0, 0.08);
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7 .Pagination_arrow__eNydl::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  border-right: 0.12em solid rgba(0, 0, 0, 0.87);
  border-top: 0.12em solid rgba(0, 0, 0, 0.87);
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7 .Pagination_arrow__eNydl.Pagination_left__\\+Uco5 {
  transform: rotate(-135deg) translate(-50%);
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7 .Pagination_arrow__eNydl.Pagination_right__qINlI {
  transform: rotate(45deg);
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7.Pagination_disabled__4m4ke {
  pointer-events: none;
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7.Pagination_disabled__4m4ke .Pagination_arrow__eNydl::before {
  border-right: 0.12em solid rgba(0, 0, 0, 0.43);
  border-top: 0.12em solid rgba(0, 0, 0, 0.43);
}
.Pagination_pagination-container__Helby .Pagination_pagination-item__mZ9-7.Pagination_disabled__4m4ke:hover {
  background-color: transparent;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/views/Search/Pagination/Pagination.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AACJ;AACI;EACE,6BAAA;EACA,eAAA;AACN;AACI;EACE,qCAAA;EACA,eAAA;AACN;AAEI;EACE,qCAAA;AAAN;AAIM;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,8CAAA;EACA,4CAAA;AAFR;AAKM;EACE,0CAAA;AAHR;AAMM;EACE,wBAAA;AAJR;AAQI;EACE,oBAAA;AANN;AAQM;EACE,8CAAA;EACA,4CAAA;AANR;AASM;EACE,6BAAA;EACA,eAAA;AAPR","sourcesContent":[".pagination-container {\n  display: flex;\n  list-style-type: none;\n  justify-content: center;\n\n  .pagination-item {\n    padding: 0 12px;\n    height: 32px;\n    text-align: center;\n    margin: auto 4px;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    letter-spacing: 0.01071em;\n    border-radius: 16px;\n    line-height: 1.43;\n    font-size: 13px;\n    min-width: 32px;\n\n    &.dots:hover {\n      background-color: transparent;\n      cursor: default;\n    }\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.04);\n      cursor: pointer;\n    }\n\n    &.selected {\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n\n    .arrow {\n      &::before {\n        position: relative;\n        content: \"\";\n        display: inline-block;\n        width: 0.4em;\n        height: 0.4em;\n        border-right: 0.12em solid rgba(0, 0, 0, 0.87);\n        border-top: 0.12em solid rgba(0, 0, 0, 0.87);\n      }\n\n      &.left {\n        transform: rotate(-135deg) translate(-50%);\n      }\n\n      &.right {\n        transform: rotate(45deg);\n      }\n    }\n\n    &.disabled {\n      pointer-events: none;\n\n      .arrow::before {\n        border-right: 0.12em solid rgba(0, 0, 0, 0.43);\n        border-top: 0.12em solid rgba(0, 0, 0, 0.43);\n      }\n\n      &:hover {\n        background-color: transparent;\n        cursor: default;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination-container": `Pagination_pagination-container__Helby`,
	"pagination-item": `Pagination_pagination-item__mZ9-7`,
	"dots": `Pagination_dots__Zgesj`,
	"selected": `Pagination_selected__0m73l`,
	"arrow": `Pagination_arrow__eNydl`,
	"left": `Pagination_left__+Uco5`,
	"right": `Pagination_right__qINlI`,
	"disabled": `Pagination_disabled__4m4ke`
};
export default ___CSS_LOADER_EXPORT___;
